import React, { useMemo, useState } from 'react';
import { DialogControl, MultiSelectListControl } from 'spark-core-dx/components';
import { useDashboardDomainContext } from '../../DashboardDomainProvider';

const InactiveVisualsDialog = ({ isActive, closeDialog }) => {
  const { inactivePageVisuals, dashboardLib } = useDashboardDomainContext();
  const [selectedValues, setSelectedValues] = useState([]);

  const visualOptions = useMemo(
    () =>
      (inactivePageVisuals ?? [])
        .map((visual) => ({
          Text: visual?.Name || 'Untitled Visual',
          Value: visual?.VisualId,
        }))
        .filter((item) => !!item?.Value),
    [inactivePageVisuals]
  );

  const selectedVisual = useMemo(
    () => (inactivePageVisuals ?? []).find((visual) => String(visual?.VisualId) === String(selectedValues?.[0] ?? '')) ?? null,
    [inactivePageVisuals, selectedValues]
  );

  const handleClose = () => {
    setSelectedValues([]);
    closeDialog();
  };

  return (
    <DialogControl
      className="dashboard-dialog"
      openDialog={isActive}
      title="Page Visuals"
      disableOk={!selectedVisual}
      onOk={async () => {
        if (!selectedVisual) {
          return;
        }

        await dashboardLib.activateVisual(selectedVisual);
        handleClose();
      }}
      onCancel={handleClose}
      okText="Activate"
    >
      <div className="dialog-text">
        <div className="title">Select an inactive visual on this page</div>
        <MultiSelectListControl
          metadata={{ DataJson: visualOptions }}
          customDisabledText="No inactive visuals found."
          value={selectedValues}
          onChange={(value) => setSelectedValues(Array.isArray(value) ? value.slice(-1) : [])}
        />
      </div>
    </DialogControl>
  );
};

export default InactiveVisualsDialog;
